<template>
  <div v-if="haveRegisteredUsers" class="card-body mb-5 mt-3">
    <h1 class="ml-3 mb-2 light-weight">See who's Registered</h1>
    <h4 class="ml-3 mb-4 light-weight">Click someone to check them in</h4>

    <div v-for="pair in registeredPairs" :key="pair[0].id + '|' + (pair.length == 2 ? pair[1].id : '')" class="col">
      <div class="row m-3 card-deck">
        <div v-for="user in pair" class="py-2 card shade"
             :class="{ 'bg-success': checkedInUsers[user.id], 'pointer': !isPast }"
             :key="user.id"
             @mouseenter="addCardDarken($event, { root: true })"
             @mouseleave="removeCardDarken($event, { root: true })"
             @click="toggleCheckIn($event, user.id)">
          <h5
            class="ml-3 mid-weight"
            :class="{ 'font-italic': !user.name, 'text-secondary': !user.name }">{{ user.name || '[No name]' }}</h5>
          <h5 class="ml-3 light-weight font-1rem">{{ user.email }}</h5>
          <h5 class="ml-3 light-weight font-1rem">{{ user.quantity }} {{ user.quantity == 1 ? 'spot' : 'spots' }}</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardMixin from '../mixins/card'
import EventsMixin from '../mixins/events'
import { makePairs } from '../utils'

export default {
  mixins: [
    {
      methods: {
        checkUserIn: EventsMixin.methods.checkUserIn,
        checkUserOut: EventsMixin.methods.checkUserOut,
        addCardDarken: CardMixin.methods.addCardDarken,
        removeCardDarken: CardMixin.methods.removeCardDarken
      }
    }
  ],
  props: {
    registeredUsers: {
      type: Object,
      required: true
    },
    checkedInUsers: {
      type: Object,
      require: true
    },
    eventId: {
      type: String,
      required: true
    },
    isPast: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    haveRegisteredUsers () {
      return Object.keys(this.registeredUsers).length > 0
    },
    sortedIds () {
      const allRegistered = this.registeredUsers

      const withName = Object.filter(allRegistered, user => user.name)
      const noName = Object.filter(allRegistered, user => !user.name)

      const withNameSorted = Object.keys(withName)
        .sort((uid1, uid2) => {
          const lastNames = [uid1, uid2].map(uid => {
            const splitName = allRegistered[uid].name.split(' ')
            return splitName[splitName.length - 1]
          })
          return lastNames[0] < lastNames[1] ? -1 : 1
        })

      const withoutNameSorted = Object.keys(noName).sort()

      return withNameSorted.concat(withoutNameSorted)
    },
    registeredPairs () {
      return makePairs(this.registeredUsers, { fill: true, keys: this.sortedIds })
    }
  },
  methods: {
    toggleCheckIn (event, userId) {
      if (this.isPast) {
        return
      }
      // This event gets fired by either the <div> or one of its children <h5>s
      // We want to select the <div>, for it is the element who's classList we want
      let divElt = event.target
      if (divElt.tagName !== 'DIV') {
        divElt = divElt.parentNode
      }

      if (this.checkedInUsers[userId]) {
        this.checkUserOut(this.eventId, userId)
          .then(() => { this.checkedInUsers[userId] = false })

        // Origninally this click event had some effect on the toggling of the
        // <div>'s darken class, but this fixes it
        divElt.classList.remove('darken')
      } else {
        this.checkUserIn(this.eventId, userId)
          .then(() => { this.checkedInUsers[userId] = true })

        divElt.classList.add('darken')
      }
    }
  }
}
</script>

<style scoped>
@import "../assets/styles/card.css";

.card.pointer {
  cursor: pointer;
}

.font-1rem {
  font-size: 1rem;
}
</style>
